import collectionClientApi from "utils/protected-client-api";
import { v4 } from "uuid";
export const isValidImgUrl = (url: string) => {
  const img = new Image();
  img.src = url;
  return new Promise((resolve) => {
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
  });
};

export function dataURLtoFile(dataURL, filename) {
  const byteString = atob(dataURL.split(",")[1]);
  const mimeString = dataURL.split(",")[0].split(":")[1].split(";")[0];
  const buffer = new ArrayBuffer(byteString.length);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < byteString.length; i++) {
    view[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([buffer], { type: mimeString });

  // Convert Blob to File
  return new File([blob], filename, { type: mimeString });
}

export const makeSquareImage = async (image: File | string) => {
  let url = "";

  if (image instanceof File) {
    url = createImagePreviewUrlFromFile(image);
  } else {
    url = image;
  }

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.setAttribute("crossorigin", "anonymous");
    var canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    img.src = url;
    img.onload = () => {
      const minVal = Math.min(img.width, img.height);
      canvas.width = minVal;
      canvas.height = minVal;

      // Calculate the starting x and y coordinates for cropping
      const offsetX = (img.width - minVal) / 2;
      const offsetY = (img.height - minVal) / 2;

      // Draw the cropped square image onto the canvas
      context?.drawImage(
        img,
        offsetX,
        offsetY,
        minVal,
        minVal,
        0,
        0,
        minVal,
        minVal
      );
      resolve(canvas.toDataURL("image/png"));
    };
  });
};

export function dataURLtoBlob(dataURL) {
  const byteString = atob(dataURL.split(",")[1]);
  const mimeString = dataURL.split(",")[0].split(":")[1].split(";")[0];
  const buffer = new ArrayBuffer(byteString.length);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < byteString.length; i++) {
    view[i] = byteString.charCodeAt(i);
  }
  return new Blob([buffer], { type: mimeString });
}

export const getImageFileByUrl = async (url: string): Promise<File> => {
  try {
    const response = await fetch(url);
    const contentType = response.headers.get("Content-Type");
    if (contentType?.includes("image")) {
      const imageBody = await response.blob();
      const extension = contentType.split("/")[1];
      const file = new File([imageBody], `${v4()}.${extension}`, {
        lastModified: new Date().getTime(),
        type: contentType,
      });
      return file;
    } else {
      throw new Error("Unspported file type");
    }
  } catch (e) {
    throw new Error("Unspported file type");
  }
};

export const createImagePreviewUrlFromFile = (file: File) => {
  const url = URL.createObjectURL(file);
  return url;
};

export const uploadImage = async (file: File & { key: string }) => {
  const fileName = file.key;
  const fileType = file.type;

  const response = await collectionClientApi.getPresignedUrl({
    fileName,
    fileType,
  });

  const { url, fields } = response;

  const formData = new FormData();

  Object.entries({ ...fields, file }).forEach(([key, value]) => {
    formData.append(key, value as string);
  });

  await collectionClientApi.uploadImageByFile(url, formData);

  return {
    url: `${url}/${fields.key}`,
  };
};

export function forceDownload(blobUrl: string, filename: string) {
  let a: any = document.createElement("a");
  a.download = filename;
  a.href = blobUrl;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export function downloadPhoto(url: string, filename: string) {
  fetch(url, {
    headers: new Headers({
      Origin: location.origin,
    }),
    mode: "cors",
  })
    .then((response) => response.blob())
    .then((blob) => {
      let blobUrl = window.URL.createObjectURL(blob);
      forceDownload(blobUrl, filename);
    });
}

export function appendNewToName(name: string) {
  let insertPos = name.indexOf(".");
  let newName = name
    .substring(0, insertPos)
    .concat("-new", name.substring(insertPos));
  return newName;
}

export const blobToBase64 = (
  blob: Blob
): Promise<string | ArrayBuffer | null> => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise((resolve) => {
    reader.onloadend = function () {
      const base64Data = reader.result;
      resolve(base64Data);
    };
  });
};
